import { h } from 'preact';

export default function ErrorSolid(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        d="M16 2a14 14 0 100 28 14 14 0 000-28zm0 22a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm1.5-6.5a1.5 1.5 0 11-3 0v-8a1.5 1.5 0 113 0v8z"
      />
    </svg>
  );
}

